import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
    'routeLeaving.description': {
        defaultMessage: 'If you leave this page your changes will be lost.',
        id: 'routeLeaving.description'
    },
    'routeLeaving.discardChanges': {
        defaultMessage: 'Do you want to discard changes?',
        id: 'routeLeaving.discardChanges'
    }
});
